import { createSelector } from '@reduxjs/toolkit';

import { RootState } from 'types';
import { initialState } from '.';

const selectSlice = (state: RootState) => state.paternCompare || initialState;

export const selectPaternCompare = createSelector(
  [selectSlice],
  state => state,
);
